import {
  RespellingRegion,
  RespellingRegionEnum,
} from '@replacements/context/ReplacementsDictionaryContext';
import { WordWithRange } from '@replacements/hooks/floatingReplacementsToolbar/useWordSelection';
import { LoadOxfordSuggestionsFn } from '@replacements/hooks/replacementsDictionary/useLazyOxfordSuggestions';
import { ReplacementSuggestion } from '@replacements/types/replacementsDictionaryTypes';

type FetchRespellingSuggestionsParams = {
  word: string;
  wordWithRange?: WordWithRange | null;
  loadSuggestionsFn: LoadOxfordSuggestionsFn;
  handleSelect?: any;
};

export const fetchRespellingSuggestions = async ({
  word,
  wordWithRange,
  loadSuggestionsFn,
  handleSelect,
}: FetchRespellingSuggestionsParams) => {
  if (!word.trim()) return;

  try {
    const { data } = await loadSuggestionsFn({ inputs: { word } });

    const mapSuggestions = (
      list: { respelling: string }[],
      region: RespellingRegion
    ): ReplacementSuggestion[] =>
      list.map((suggestion, index) => {
        const onAddParams = wordWithRange
          ? { text: word, replacement: suggestion.respelling }
          : suggestion.respelling;
        return {
          id: `${region}-${index}`,
          label: suggestion.respelling,
          isAdded: false,
          onSelect: () =>
            handleSelect && handleSelect(onAddParams, wordWithRange),
        };
      });

    if (data.respellingSuggestionsByRegion) {
      const { us, uk } = data.respellingSuggestionsByRegion;
      return {
        us: mapSuggestions(us ?? [], RespellingRegionEnum.us),
        uk: mapSuggestions(uk ?? [], RespellingRegionEnum.uk),
      };
    }
  } catch (err) {
    console.warn('Unexpected error while fetching dictionary suggestions', err);
  }

  return undefined;
};

export default fetchRespellingSuggestions;
